/**
 * Generic modal
 * @method setAlertModal
 * @method setLoadingModal
 * @method setConfirmModal
 * authen modal
 * @method setOtpModal
 */
export function ModalController() {
    //generic
    this.alertModal = null;
    this.loadingModal = null;
    this.confirmModal = null
    this.transferConfirmModal = null

    //#region generic
    this.setAlertModal = function (alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setTransferConfirmModal = function (controller) {
        this.transferConfirmModal = controller
    }
    //#endregion generic

    //#region authen
    this.otpModal = null;
    this.setOtpModal = function (otpModalController) {
        this.otpModal = otpModalController;
    };
    //#endregion authen




}
